export const NEWS_FEED_DASHBOARD_PARAMS = {
  page: 1,
  pageSize: 10,
  filter: 'newsFeed',
};
